import React, { Component } from "react";
import "./index.scss";
import AxiosClient from "../../Network/AxiosClient";
import CallCard from "./components/callCard";
import GradientBG from "./img/BlurredBG.svg";
import GeographyFilters from "../Shared/GeographyFilters";
import Loader from "../Shared/Loader";
import dummyData from "./helper/dataSkeleton";
//import Pagination from "../Shared/Pagination/Pagination";
import Pagination from "../Shared/DexterPagination/Pagination";
import DatePicker from "../Shared/GeographyFilters/components/datePicker";
import { format, subDays } from "date-fns";
import { Redirect } from "react-router-dom";
import LatestCallReportDownload from "./components/LatestCallReportDownload";

export default class NewCalls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calls: [],
      total: null,
      limit: 24,
      page: 1,
      isFetching: true,
      geographyFilters: {
        clusters: [],
        agency: [],
        region: [],
        area: [],
        territory: [],
        field_force_id: [],
        team: [],
        call_outcome: [],
        qr_status: [],
        outlet_status: [],
      },
      dateRange: [
        {
          startDate: subDays(new Date(), 0),
          endDate: subDays(new Date(), 0),
          key: "selection",
        },
      ],
    };
  }

  componentDidMount() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (localUserToken) this.fetchCallData();
  }

  fetchCallData = () => {
    this.setState({ isFetching: true });

    const startDate = this.state.dateRange[0].startDate;
    const endDate = this.state.dateRange[0].endDate;

    const callListParams = {
      start_time: format(new Date(startDate), "yyyy-MM-dd"),
      end_time: format(new Date(endDate), "yyyy-MM-dd"),
      page_size: this.state.limit,
      page_index: this.state.page - 1,
      ...this.state.geographyFilters,
    };

    AxiosClient.get(`${process.env.REACT_APP_API_URL}/api/calls/v1/list`, {
      params: callListParams,
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("currUserToken")),
      },
    })
      .then((res) => {
        return this.setState({
          calls: res.data.data,
          total: res.data.count,
          limit: res.data.limit,
          isFetching: false,
        });
      })
      .catch(() =>
        this.setState({
          isFetching: false,
        })
      );
  };

  onPageChange = (page) => {
    this.setState({ page: page }, () => this.fetchCallData());
  };
  onApplyDateRangeChange = (item) => {
    this.setState({ dateRange: [item.selection], page: 1 }, () =>
      this.fetchCallData()
    );
  };
  onApplyGeographyFilter = (e) => {
    this.setState({ geographyFilters: { ...e }, page: 1 }, () =>
      this.fetchCallData()
    );
  };
  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    return (
      <div className="new-calls-container">
        {/* <img src={GradientBG} className="gradient-bg-image" /> */}
        <div className="new-call-geo-filters">
          <GeographyFilters
            {...this.state.geographyFilters}
            onFilterChange={this.onApplyGeographyFilter}
            includeDatePicker={false}
            dateRange={this.state.dateRange}
            onChangeDateRange={this.onApplyDateRangeChange}
            label="Calls"
            isCallFilter={true}
          />
          {
            <div
              className={
                this.state.isFetching
                  ? "new-call-pagination disabled"
                  : "new-call-pagination"
              }
            >
              <div className="action-bar">
                {" "}
                <LatestCallReportDownload />
                <div>
                  <DatePicker
                    dateRange={this.state.dateRange}
                    onChangeDateRange={this.onApplyDateRangeChange}
                  />
                </div>
              </div>

              <Pagination
                currentPage={this.state.page}
                totalCount={this.state.total}
                pageSize={this.state.limit}
                onPageChange={this.onPageChange}
              />
            </div>
          }
        </div>

        <div className="new-calls-cards-container">
          {this.state.isFetching && <FetchingOverlay />}
          {this.state.total === 0 && (
            <h2 className="no-data-container">No data available</h2>
          )}
          {this.state.calls.map((card) => (
            <CallCard
              key={card.id}
              cardInfo={{
                ...card,
                startDate: this.state.dateRange[0].startDate,
                endDate: this.state.dateRange[0].endDate,
              }}
            />
          ))}
        </div>
      </div>
    );
  }
}

const FetchingOverlay = () => {
  return (
    <div className="fetching-overlay">
      <Loader name="call" />
    </div>
  );
};
